module.exports = __webpack_public_path__ + "static/media/cadastro_de_kit.f9e4402a.pdf";